// DAZN supported countries (limited to IT and CH)
export const DAZN_COUNTRIES = [
  { code: 'IT', name: 'Italia', flag: '\u{1F1EE}\u{1F1F9}' },
  { code: 'CH', name: 'Svizzera', flag: '\u{1F1E8}\u{1F1ED}' },
];

// DAZN supported language codes
export const DAZN_LANGUAGES = [
  { code: 'it', name: 'Italiano' },
  { code: 'de', name: 'Deutsch' },
  { code: 'fr', name: 'Français' },
  { code: 'en', name: 'English' },
];

// Timezones (limited to IT and CH)
export const TIMEZONES = [
  { code: 'Europe/Rome', name: 'Italia (UTC+1/+2)' },
  { code: 'Europe/Zurich', name: 'Svizzera (UTC+1/+2)' },
];

// Auto-select timezone from country
export const COUNTRY_TIMEZONE_MAP: Record<string, string> = {
  IT: 'Europe/Rome',
  CH: 'Europe/Zurich',
};

// Auto-select language from country
export const COUNTRY_LANGUAGE_MAP: Record<string, string> = {
  IT: 'it',
  CH: 'de',
};

// Default values for DAZN account. No user agent here: the server hands out the account's identity defaults (the Android
// TV user agent, GET /dazn/account `identityDefaults`, see utils/dazn-account-form.ts).
export const DAZN_DEFAULTS = {
  PIN: '0000',
  COUNTRY: 'IT',
  LANGUAGE: 'it',
  TIMEZONE: 'Europe/Rome',
};
